import { JSX } from 'react';

import styled from 'styled-components';

interface WrapperProps {
  src?: string;
}

export const Wrapper = styled.img<WrapperProps>`
  color: var(--require-red);
  margin-right: 5px;
  font-size: 14px;
  font-weight: bold;
  display: inline;
  vertical-align: middle;
  src: ${({ src }) => (src ? `url(${src})` : 'none')};
`;

function RequireIndicator(): JSX.Element {
  return (
    <Wrapper
      src="/food/onboarding/assets/Required_Ellipse.svg"
      alt="tooltip-img"
    />
  );
}

export default RequireIndicator;